import payment_amazon_pay from './svg/amazon_pay.svg';
import payment_american_express from './svg/american_express.svg';
import payment_apple_pay from './svg/apple_pay.svg';
import payment_axepta from './svg/axepta.svg';
import payment_bank_transfer from './svg/bank_transfer.svg';
import payment_beneficy from './svg/beneficy.svg';
import payment_diners from './svg/diners.svg';
import payment_discover from './svg/discover.svg';
import payment_google_pay from './svg/google_pay.svg';
import payment_jointly from './svg/jointly.svg';
import payment_maestro from './svg/maestro.svg';
import payment_mastercard from './svg/mastercard.svg';
import payment_offline from './svg/offline.svg';
import payment_paypal from './svg/paypal.svg';
import payment_satispay from './svg/satispay.svg';
import payment_scalapay from './svg/scalapay.svg';
import payment_sepa from './svg/sepa.svg';
import payment_stripe from './svg/stripe.svg';
import payment_tantosvago from './svg/tantosvago.svg';
import payment_unionpay from './svg/unionpay.svg';
import unknown_pay from './svg/unknown_pay.svg';
import payment_visa from './svg/visa.svg';

const svgs = {
  payment_amazon_pay,
  payment_american_express,
  payment_amex: payment_american_express,
  payment_apple_pay,
  payment_axepta,
  payment_bank_transfer,
  payment_beneficy,
  payment_card: unknown_pay,
  payment_diners,
  payment_discover,
  payment_google_pay,
  payment_jointly,
  payment_maestro,
  payment_mastercard,
  payment_offline,
  payment_paypal,
  payment_satispay,
  payment_scalapay,
  payment_sepa,
  payment_sepa_debit: payment_sepa,
  payment_stripe,
  stripe: payment_stripe,
  payment_tantosvago,
  payment_unionpay,
  payment_visa,
  unknown_pay,
};

export type SvgPaymentsList = keyof typeof svgs;
export default svgs;
